import {API_URL_KYC} from '../constants';

export const apiBaseKyc = {
  baseUrl: API_URL_KYC,
  endpoints: {
    postTokenPlaid: '/customer/v1/plaid/token',
    postTokenIdvPlaid: '/customer/v1/plaid/token-idv',
    postDocsSubmitted: '/customer/v1/docs-submitted',
    putUploadAdditionalDocument: '/customer/v1/additional-document',
  },
};

export const CKycDocumentTypes = {
  DocumentUtilityBill: 'UTILITY_BILL',
  DocumentPhoneBill: 'PHONE_BILL',
} as const;
